import React from 'react';

import './popupactions.scss';

export default function PopupActions ({children}) {
	return (
		<div className="popup-actions">
			{children}
		</div>
	)
}
